import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgxSpinnerModule]
})
export class SpinnerComponent implements OnInit {
  @Input() name: string;
  @Input() fullScreen: boolean = true;
  constructor() { }

  ngOnInit(): void {
  }

}
